import css from "styled-jsx/css";
import getColor, { COLOR_DICTIONARY } from "@gc-npm/utils.enums.colors";

export default css`
  .device-card {
    width: 100%;
    padding: 0 0.5rem;

    :global(.cms-label .text) {
      @media (max-width: 405px) and (min-width: 336px) {
        font-size: 13px !important;
      }
    }

    /* Contingencia textos largos (tam. no standard) para que no vayan a 2 lineas*/
    :global(.crazy-label) {
      @media (max-width: 405px) and (min-width: 336px) {
        font-size: 12px;
      }
    }
    
    &--container {
      width: 100%;
      margin-top: 1rem;
      &--offer {
        margin-bottom: 0.3rem;
      }
      &--image-stamp-container {
        height: 11.5rem;
        margin-bottom: 0.75rem;
        &--stamp {
          display: flex;
          justify-content: center;
          //margin-bottom: 0.5rem;
          margin-top: 0.1rem;
        }
        &--image-box {
          position: relative;
          height: 100%;
        }
        // Si hay sello la imagen del terminal la hago mas pequeña
        &--image-box.with-stamp {
          height: 9.5rem !important;
        }
      }

      &--post-saving {
        margin-bottom: 6px;
      }
      &--name {
        min-height: 3.75rem;

        :global(.text) {
          display: -webkit-box;
          -webkit-line-clamp: 3;
          -webkit-box-orient: vertical;
          overflow: hidden;
          text-overflow: ellipsis;
          line-height: 110% !important;
          display: none;
        }
      }
      &--pretitle {
        :global(.text) {
          margin-bottom: 4px;
          display: -webkit-box;
          -webkit-line-clamp: 1;
          -webkit-box-orient: vertical;
          overflow: hidden;
          text-overflow: ellipsis;
        }
      }
      &--label {
        padding-bottom: 6px;
        height: auto;
        display: flex;
        justify-content: flex-start;
        align-items: center;
      }
      &--price-box {
        display: flex;
        justify-content: flex-start;
        align-items: center;
        flex-wrap: wrap;
        &--relative {
          display: flex;
          gap: 0.25rem;
          align-items: baseline;
          position: relative;
          margin-right: 0.5rem;
        }
      }
      &--bottom-text {
        width: 100%;
        min-height: 14px;
      }
      &--eficiency-label {
        margin-top: 1rem;
        padding: 2px;
        z-index: 3;
        :global(img) {
          display:flex;
        }
      }
      &--eficiency-label:hover {
        background-color: #EEEEEE;
        border-radius: 4px;
      }
      &--additionalPayment {
        min-height: 14px;
      }
      &--previous-price :global(.price) {
        text-decoration-line: line-through;
        text-decoration-thickness: 1.5px;
        text-decoration-color: ${getColor(COLOR_DICTIONARY.GREY_600)};
      }
      &--line-freeOffer {
        border-bottom: 1px solid #ddd;
        margin: 0.25rem 0;
      }
    }
  }

  :global(.device-card .card) {
    height: 100% !important;
  }

  :global(.device-card .layout-device) {
    padding: 0.5rem;
  }

  :global(.device-card .card) {
    height: 100% !important;
  }

  :global(.device-card--container--label:empty) {
    display: none !important;
  }

  :global(.device-card--container--price-box .price .price--unity > span) {
    margin-left: 0.15rem;
  }

  :global(.device-card--container--price-box .price .price--quote > span) {
  }

  :global(
      .device-card--container--price-box--promo .price .price--unity > span
    ) {
    margin-left: 0.15rem;
  }

  :global(
      .device-card--container--price-box--promo .price .price--quote > span
    ) {
  }

  /* Desktop */
  @media screen and (min-width: 768px) {
    .device-card {
      &--container {
        width: 100%;
      }
    }
  }
`;
